import { z } from 'zod';

import { PREVIEW_MAX_LENGTH } from '../_shared/preview';
import {
  CardCompanySnapshotSchema,
  CardCustomerSnapshotSchema,
  CardOriginChannelSchema,
} from '../card/card';
import { CardIdSchema } from '../card/card_id';
import { PrioritySchema } from '../card/priority';
import { ProjectIdSchema } from '../project/project';

/**
 * One row of the triage inbox (`GET /orgs/:orgId/triage-cards`): an open
 * card with no squad awaiting human routing. Distinct from `OverviewRow`
 * (the operator's landing buckets) — triage cards may carry `projectId: null`.
 */
export const TriageCardRowSchema = z.object({
  cardId: CardIdSchema,
  projectId: ProjectIdSchema.nullable(),
  customer: CardCustomerSnapshotSchema,
  company: CardCompanySnapshotSchema,
  preview: z.string().max(PREVIEW_MAX_LENGTH),
  priority: PrioritySchema,
  originChannel: CardOriginChannelSchema,
  createdAt: z.coerce.date(),
});

export type TriageCardRow = z.infer<typeof TriageCardRowSchema>;
